import { css } from '@emotion/react'
import { size } from '@twistopayments/design-system/styles'

export const iconButton = css`
  & a {
    span {
      display: flex;
      align-items: center;
      gap: ${size[12]};
    }
  }
`
